
jQuery(document).ready(function($){
    $(window).on("scroll", function () {
        if ($(window).scrollTop()) {
            $('#mainNav').addClass('scroll');
        } else {
            $('#mainNav').removeClass('scroll');
        }
    });

    $(".menu-toggle").on("click", function(e) {
        if($("#mainNav").hasClass("open")) {
            $("#mainNav").removeClass("open");
        } else {
            $("#mainNav").addClass("open");
        }
    });
});